import { Collapser } from '../Collapser';

export function collapseWhenDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: collapseWhenDirectiveCtrl,
	};
}

class collapseWhenDirectiveCtrl {
	constructor($scope, $element, $attrs, $timeout) {
		'ngInject';
		// $element.css('display', 'none');
		// run setup after attributes have time to be interpolated
		// or maybe we need to run post link?
		// setTimeout(() => {
		// 	$element.css('display', 'block');
		let shouldBeOpen = () => {
			return !$scope.$eval($attrs.shCollapseWhen);
		};
		let options = {
			isOpen: shouldBeOpen(),
			duration: $scope.$eval($attrs.shCollapseDuration) || 400,
			handleClick: false,
			trigger: $attrs.shCollapseTrigger,
			show: $scope.$eval($attrs.shCollapseShow) || '',
		};
		let collapseShowWatch = $scope.$eval($attrs.shCollapseShowWatch);
		let collapser = new Collapser($element, options, $timeout);
		$scope.$watch($attrs.shCollapseWhen, (newVal, oldVal) => {
			if (oldVal === newVal) {
				// console.log('newVal === oldVal', true);
				return;
			}

			if (shouldBeOpen()) {
				$timeout(() => {
					// make sure content inside the collapsed element has time to render
					collapser.open();
				}, 0);
			} else {
				if (options.show) {
					$timeout(() => {
						// make sure content inside the collapsed element has time to render
						collapser.close();
					}, 0);
				} else {
					collapser.close();
				}
			}
		});

		if (collapseShowWatch !== undefined) {
			$scope.$watch($attrs.shCollapseShowWatch, (newVal, oldVal) => {
				if (oldVal === newVal || shouldBeOpen() || !options.show) {
					return;
				}
				$timeout(() => {
					// make sure content inside the collapsed element has time to render
					collapser.close();
				}, 0);
			});
		}
		// }, 0);
	}
}
